<template>
  <v-container fluid class="d-flex justify-center" :style="`margin-left: ${margin}`">
    <div class="report-wrapper">
      <!-- Sticky Filter Header -->
      <div class="table-header-filters">
        <v-row dense class="align-center">
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-menu v-model="reportFromMenu" offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="filter-select"
                  :value="formatDateFrom"
                  label="Od datuma"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateFrom" no-title scrollable @input="reportFromMenu = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="2">
            <v-menu v-model="reportToMenu" offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="filter-select"
                  :value="formatDateTo"
                  label="Do datuma"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateTo" no-title scrollable @input="reportToMenu = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              class="filter-select"
              dense
              outlined
              hide-details
              label="Prodajno mjesto"
              v-model="location"
              :items="locations"
              item-text="name"
              item-value="id"
              return-object
            ></v-autocomplete>
          </v-col>

          <!-- Action Cluster -->
          <v-col cols="auto" class="ml-auto d-flex align-center" style="gap: 8px">
            <v-btn :disabled="locationNotSelected" class="search-btn" @click="getData()" small>
              <v-icon small class="mr-1">mdi-magnify</v-icon>
              Pretraži
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-menu offset-y left :close-on-content-click="true">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-btn icon class="export-btn" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                      <v-icon color="#00b3be">mdi-export-variant</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense style="border-radius: 12px; overflow: hidden; padding: 4px; min-width: 140px;">
                    <v-list-item @click="changeWidth()">
                      <v-icon size="18" color="#E53935" class="mr-2">mdi-file-pdf-box</v-icon>
                      <v-list-item-title>PDF</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="generateExcel()">
                      <v-icon size="18" color="#43A047" class="mr-2">mdi-file-excel</v-icon>
                      <v-list-item-title>Excel</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <span>Izvoz podataka</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon :to="to" class="close-btn" v-bind="attrs" v-on="on">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Zatvori izvještaj</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>

      <!-- Glass Table Wrapper -->
      <div class="glass-table-wrapper">
        <div id="table_info" class="table-content">
          <!-- Hidden company info table for PDF -->
          <table id="firma" style="display: none; font-family: 'Roboto-Regular'">
            <tbody>
              <tr>
                <td>{{ company ? $options.filters.capitalize(company.name) : "" }}</td>
              </tr>
              <tr>
                <td>{{ company ? company.address + " " + company.city : "" }}</td>
              </tr>
              <tr>
                <td>OIB: {{ company ? company.oib : "" }}</td>
              </tr>
              <tr>
                <td>Prodajno mjesto: {{ location ? location.name : "" }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Report Title -->
          <div style="font-family: Raleway, sans-serif;">
            <table justify="center" style="width: 100% !important; border: 0 !important" cellspacing="0" id="title">
              <thead>
                <tr class="pb-0 mb-0">
                  <th colspan="6" class="pb-0 mb-0">
                    <p class="gradient-text" style="font-size: 25px; text-align: center;">
                      Rekapitulacija napojnica
                    </p>
                  </th>
                </tr>
                <tr class="pa-0 ma-0">
                  <th colspan="6">
                    <p style="font-weight: bold; font-size: 12px; text-align: center;">
                      za razdoblje od {{ formatDateFrom }} do {{ formatDateTo }}
                    </p>
                  </th>
                </tr>
              </thead>
            </table>
          </div>

          <!-- Tips Table -->
          <div justify="center">
            <table
              justify="center"
              style="width: 100% !important"
              cellspacing="0"
              id="tableTraffic"
              class="tableTraffic"
              v-if="showTableData"
            >
              <tbody v-for="seller in sellers" :key="seller.id" style="min-width: 100% !important">
                <tr class="seller-header">
                  <td style="text-transform: uppercase">{{ seller.name }}</td>
                  <td>Količina napojnica - {{ seller.cash_amt + seller.card_amt }}</td>
                </tr>
                <tr class="payment-method-header">
                  <td colspan="2">Način plaćanja</td>
                </tr>
                <tr>
                  <td>Gotovina</td>
                  <td>
                    {{
                      viewType === "pdf"
                        ? $options.filters.money(seller.cash, 100, currency).replace("€", "")
                        : seller.cash / 100
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Kartice</td>
                  <td>
                    {{
                      viewType === "pdf"
                        ? $options.filters.money(seller.card, 100, currency).replace("€", "")
                        : seller.card / 100
                    }}
                  </td>
                </tr>
                <tr class="subtotal-row">
                  <td>Ukupno</td>
                  <td>
                    {{
                      viewType === "pdf"
                        ? $options.filters.money(seller.card + seller.cash, 100, currency).replace("€", "")
                        : (seller.card + seller.cash) / 100
                    }}
                  </td>
                </tr>
                <tr style="background-color: white; border: 0px white !important">
                  <td colspan="3">&nbsp;</td>
                </tr>
              </tbody>
              <tbody style="min-width: 100% !important">
                <tr class="total-header">
                  <td colspan="2">Ukupno po načinima plaćanja</td>
                </tr>
                <tr>
                  <td>Gotovina</td>
                  <td>
                    {{
                      viewType === "pdf"
                        ? $options.filters.money(total.cash, 100, currency).replace("€", "")
                        : total.cash / 100
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Kartice</td>
                  <td>
                    {{
                      viewType === "pdf"
                        ? $options.filters.money(total.card, 100, currency).replace("€", "")
                        : total.card / 100
                    }}
                  </td>
                </tr>
                <tr class="grand-total">
                  <td>Ukupno</td>
                  <td>
                    {{
                      viewType === "pdf"
                        ? $options.filters.money(total.total, 100, currency).replace("€", "")
                        : total.total / 100
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { DAY, clone } from '@/plugins/utils'
import { df, auth } from '@/plugins/firebase'
import state from '@/state'
import 'jspdf-autotable'
import { saveExcel } from '@/modules/all-reports/xlsx/config.js'
import EventBus from '@/plugins/event-bus'
import { initPdf, setTable, setPageNumber } from '@/modules/all-reports/pdf/config.js'

export default {
  name: 'Reports',
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  components: {},
  data: function () {
    return {
      dateFrom: new Date(new Date().getTime() - DAY).toISOString().substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      location: null,
      locations: [],
      allTips: [],
      reportFromMenu: undefined,
      reportToMenu: undefined,
      company: undefined,
      currency: 'EUR',
      total: {
        cash: 0,
        card: 0,
        total: 0
      },
      sellers: [],
      tableWidth: '1200px',
      a4PortraitWidth: '575px',
      a4LandscapeWidth: '610px',
      targetModifier: '',
      viewType: 'pdf',
      showTableData: false,
      margin: '0px'
    }
  },
  computed: {
    to () {
      return { name: `${this.targetModifier}.all-reports.reportMenu` }
    },
    formatDateTo () {
      return new Intl.DateTimeFormat('hr-HR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }).format(new Date(this.dateTo))
    },
    formatDateFrom () {
      return new Intl.DateTimeFormat('hr-HR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }).format(new Date(this.dateFrom))
    },
    locationNotSelected () {
      return !this.location || !this.location.id
    }
  },
  async created () {
    this.margin = state.getMargin()
    await this.getPointsOfSale()
  },
  mounted () {
    var sideNav = this.$route.meta.sideNav
    switch (sideNav) {
      case 'Companies':
        break
      case 'Company':
        this.targetModifier = 'company'
        break
      case 'PointOfSale':
        this.targetModifier = 'pointOfSale'
        break
      case 'CashRegister':
        this.targetModifier = 'pointOfSale'
        break
    }

    EventBus.$on('set-mini', () => {
      this.margin = state.getMargin()
    })

    this.company = clone(state.getCurrentCompany())
    this.location = clone(state.getPointOfSale())
  },
  methods: {
    async getData () {
      this.sellers = []
      this.tips = {
        cash: 0,
        card: 0,
        total: 0
      }
      this.total = {
        cash: 0,
        card: 0,
        total: 0
      }
      this.showLoader()
      const dateFrom = new Date(this.dateFrom).getTime() / 1000
      const dateTo = new Date(this.dateTo).getTime() / 1000

      this.allTips = []

      let query = df
        .collection('tips')
        .where('created', '>=', dateFrom)
        .where('created', '<=', dateTo + 86399)
      if (this.location && this.location.id !== 'all') {
        query = query.where('location_id', '==', this.location.id)
      }

      await query.get().then((documentSnapshots) => {
        if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
          documentSnapshots.docs.forEach((item) => {
            this.allTips.push(item.data())
          })
        }
      })

      this.allTips.sort((a, b) => a.created - b.created)

      this.allTips.forEach((tip) => {
        var seller = {
          name: tip.seller_name,
          id: tip.seller_id,
          cash: 0,
          cash_amt: 0,
          card: 0,
          card_amt: 0,
          tips: [tip]
        }
        this.total.total += tip.tip_amount

        if (tip.tip_payment_method === 'NOVČANICE') {
          this.total.cash += tip.tip_amount
          seller.cash += tip.tip_amount
          seller.cash_amt += 1
        }

        if (tip.tip_payment_method === 'KARTICA') {
          this.total.card += tip.tip_amount
          seller.card += tip.tip_amount
          seller.card_amt += 1
        }

        if (this.sellers.length === 0) {
          this.sellers.push(seller)
        } else {
          var found = false
          this.sellers.forEach((s, k) => {
            if (s.id === seller.id) {
              found = true
              if (seller.card > 0) {
                this.sellers[k].card += seller.card
                this.sellers[k].card_amt += seller.card_amt
              }

              if (seller.cash > 0) {
                this.sellers[k].cash += seller.cash
                this.sellers[k].cash_amt += seller.cash_amt
              }

              this.sellers[k].tips.push(...seller.tips)
            }
          })

          if (found === false) {
            this.sellers.push(seller)
          }
        }
      })

      this.showTableData = true
      this.hideLoader()
    },
    changeWidth () {
      this.showLoader('', { opacity: 1 })
      const tableInfo = document.getElementById('table_info')
      tableInfo.style.width = this.a4PortraitWidth
      tableInfo.style.fontSize = '80%'

      this.generatePdf()
    },
    async generatePdf () {
      const that = this
      const tableInfo = document.getElementById('table_info')
      try {
        var doc = await initPdf()

        doc = await setTable(doc, '#firma', 10)
        var finalY = doc.lastAutoTable.finalY || 10
        doc = await setTable(doc, '#title', finalY)
        finalY = doc.lastAutoTable.finalY || 10
        doc = await setTable(doc, '#tableTraffic', finalY)

        doc = await setPageNumber(doc)

        doc.save('Rekapitulacija napojnica.pdf')
      } catch (error) {
        console.error('PDF generation error:', error)
      } finally {
        tableInfo.style.width = that.tableWidth
        tableInfo.style.fontSize = '100%'
        this.viewType = 'pdf'
        that.hideLoader()
      }
    },
    generateExcel () {
      this.showLoader('', { opacity: 1 })
      this.viewType = 'excel'
      setTimeout(() => {
        var tables = ['firma', 'title', 'tableTraffic']
        var fileName = 'Rekapitulacija napojnica.xlsx'

        saveExcel(tables, fileName)

        this.viewType = 'pdf'
        this.hideLoader()
      }, 1000)
    },
    async getPointsOfSale () {
      const docRef = df.doc(`user_locations/${auth.currentUser.uid}.${state.getCurrentCompany().id}`)
      docRef.onSnapshot((doc) => {
        var locations = Object.values(doc.data().locations)
        locations.forEach((location, index) => {
          this.locations.push(location)
        })
        // Sort alphabetically
        this.locations.sort((a, b) => a.name.localeCompare(b.name))
      })
    }
  }
}
</script>

<style scoped>
/* Report Wrapper */
.report-wrapper {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

/* Sticky Filter Header */
.table-header-filters {
  position: -webkit-sticky;
  position: sticky;
  top: 64px;
  z-index: 10;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
}

.table-header-filters >>> .v-row {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.table-header-filters >>> .v-row:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

/* Filter Select Inputs */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 36px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

.close-btn {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  border-radius: 10px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(229, 57, 53, 0.2) !important;
  color: #e53935 !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

.close-btn:hover {
  background: rgba(229, 57, 53, 0.07) !important;
  box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.1) !important;
}

.search-btn {
  height: 36px !important;
  padding: 0 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

.search-btn:hover:not(:disabled) {
  border-color: #3989C9 !important;
  box-shadow: 0 2px 6px rgba(57, 137, 201, 0.2) !important;
}

.search-btn:disabled {
  opacity: 0.45 !important;
}

.export-btn {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  border-radius: 10px !important;
  background: rgba(0, 179, 190, 0.06) !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  transition: all 0.2s ease !important;
}

.export-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
  box-shadow: 0 0 0 3px rgba(0, 179, 190, 0.12) !important;
}

/* Glass Table Wrapper */
.glass-table-wrapper {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  padding: 30px;
  overflow-x: auto;
}

/* Table Content */
.table-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  font-size: 16px;
  font-family: 'Roboto-Regular', sans-serif;
}

/* Gradient Text */
.gradient-text {
  font-weight: 700 !important;
  color: #2d3748 !important;
  -webkit-text-fill-color: #2d3748 !important;
  letter-spacing: 0.3px !important;
  display: inline-block !important;
  margin: 0;
  padding: 0;
}

/* Table Styling */
.tableTraffic {
  border-collapse: collapse;
}

.glass-table-wrapper table {
  border-collapse: collapse;
  width: 100%;
  border: none;
}

.glass-table-wrapper table th,
.glass-table-wrapper table td {
  padding: 14px 20px;
  border: none;
  border-bottom: 1px solid #EDF2F7;
  font-variant-numeric: tabular-nums;
}

.glass-table-wrapper table tbody tr:hover:not(.naslov):not(.row-total) {
  background: #F7FAFC;
}

.naslov {
  background: #F8FAFC !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  color: #2D3748 !important;
}
.naslov th, .naslov td {
  color: #2D3748 !important;
  border-bottom: 2px solid #EDF2F7 !important;
}

.row-total {
  background: rgba(0, 188, 212, 0.03) !important;
  border-top: 2px solid rgba(0, 188, 212, 0.2) !important;
}
.row-total th, .row-total td {
  color: #00b3be !important;
  font-weight: 700 !important;
  border-bottom: 1px solid rgba(0, 188, 212, 0.15) !important;
}

.report-content-wrapper {
  margin-top: 40px;
}

/* Seller Header */
.seller-header {
  text-align: left;
  font-weight: 700;
  min-width: 100% !important;
  background: #00b3be;
  color: white;
}

.seller-header td {
  padding: 12px 20px;
  color: white !important;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: none !important;
}

/* Payment Method Header */
.payment-method-header {
  text-align: left;
  font-weight: 700;
  background: #F8FAFC;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #2D3748;
}

/* Subtotal Row */
.subtotal-row {
  font-weight: 700;
  background: rgba(0, 188, 212, 0.03) !important;
  border-top: 2px solid rgba(0, 188, 212, 0.2) !important;
}

.subtotal-row td {
  color: #00b3be !important;
  border-bottom: 1px solid rgba(0, 188, 212, 0.15) !important;
}

/* Total Header */
.total-header {
  text-align: left;
  font-weight: 700;
  background: #F8FAFC;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #2D3748;
}

/* Grand Total */
.grand-total {
  background: rgba(0, 188, 212, 0.06) !important;
  font-weight: 700;
  border-top: 2px solid rgba(0, 188, 212, 0.3) !important;
}

.grand-total td {
  padding: 14px 20px;
  color: #00b3be !important;
  font-size: 15px;
  border-bottom: 2px solid rgba(0, 188, 212, 0.2) !important;
}

/* Responsive Design */
@media (max-width: 960px) {
  .glass-table-wrapper {
    padding: 16px;
  }

  .table-content {
    font-size: 14px;
  }
}

@media (max-width: 600px) {
  .table-header-filters {
    padding: 12px;
  }

  .glass-table-wrapper {
    padding: 12px;
  }

  .table-content {
    font-size: 13px;
  }
}
</style>
